var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShippingHeaderAdd',{attrs:{"title":_vm.id ? _vm.$t('atualizar-transportadora') : _vm.$t('adicionar-novo-transportadora')},on:{"back":_vm.back}}),_c('ShippingAddForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }